// extracted by mini-css-extract-plugin
module.exports = {"table":"style_table__3KuU0"};